import { render, staticRenderFns } from "./GameResults.vue?vue&type=template&id=29b56b4f&scoped=true"
import script from "./GameResults.vue?vue&type=script&lang=js"
export * from "./GameResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b56b4f",
  null
  
)

export default component.exports